import { StatisticsTutor } from "../@types/globalTypes";
import SanadModel from "./SanadModel";
import SponsorshipModel from "./SponsorshipModel";
import StudentModel from "./StudentModel";
import TelawahModel from "./TelawahModel";
import UserModel from "./UserModel";

export default class TutorModel extends UserModel {
  full_name?: string;
  city?: string | null;
  native_language?: string | null;
  students?: StudentModel[] | null;
  recitation_licenses?: SanadModel[] | null;
  availabilitySchedule?: object;
  occupancyRate?: number;
  isAvailable?: boolean;
  telawahs?: TelawahModel[];
  sponsorship?: SponsorshipModel[];
  statistics?: StatisticsTutor;
  tardiness: string | number;
  external_profile_url?: string;

  constructor(arg: any) {
    super(arg);
    this.full_name = arg.full_name;
    this.city = arg.city;
    this.telawahs = arg?.telawahs ?? [];
    this.native_language = arg.native_language;
    this.occupancyRate = arg.occupancy_rate;
    this.availabilitySchedule = arg.availability_schedule;
    this.isAvailable = arg.is_available;
    this.sponsorship = arg?.sponsorship ?? [];
    this.external_profile_url = arg?.external_profile_url;
    this.statistics = arg.statistics;
    this.tardiness = !!arg?.statistics?.accumulated_delays_by_tutor
      ? (arg?.statistics?.accumulated_delays_by_tutor / 60).toFixed(0)
      : 0;
    if (!!arg.students)
      this.students = StudentModel.fromApiResponse(arg.students);
    if (!!arg.recitation_licenses)
      this.recitation_licenses = SanadModel.fromApiResponse(
        arg.recitation_licenses
      );
  }
}
